const { get, post, patch, put, destroy } = require('utils/request');

export function* sendNewMessage(data) {
  const message = yield post({
    url: `/users/sendMessage`,
    data,
  });
  return message;
}
